// Grids & Gantts — ONE work item, the whole window, and nothing else.
//
// Standard 1.6: A WORK ITEM HAS AN ADDRESS.
//
// Middle-click or Ctrl-click a work item on a grid and the
// browser should do what a browser does: open it in a new tab. What arrives
// in that tab must be THE WORK ITEM'S OWN SCREEN — not a search results page
// with one row in it, and not a structure of twenty-eight thousand rows with
// a dialog on top that the reader then has to wait for.
//
// So a page that lists work items links to ITSELF with `?item=KEY`, and when
// that parameter is present it renders this instead of its own contents. No
// new route is needed, the
// link is copyable and shareable, and — the part that matters — the page
// skips its own data load entirely. The reader asked for one work item.
//
// It is the product's IssueScreenPanel, the same screen Folders and the
// Kanban board open, every field editable. Only the chrome is different:
// no backdrop, no dialog, no Escape-to-close, because there is nothing
// behind it to go back to.

import { Component } from 'react';
import IssueScreenPanel from '@modules/database/work-items/frontend/components/IssueScreenPanel';
import { FONT } from '../structure/theme';

class PanelBoundary extends Component {
  constructor(p) { super(p); this.state = { err: null }; }
  static getDerivedStateFromError(err) { return { err }; }
  render() {
    if (this.state.err) {
      return (
        <div style={{ padding: 20, fontSize: 13, color: '#dc2626' }}>
          The work-item screen failed to render: {String((this.state.err && this.state.err.message) || this.state.err)}
        </div>
      );
    }
    return this.props.children;
  }
}

export default function WorkItemPage({ issueKey, ui, backHref, backLabel = 'the structure', onChanged }) {
  if (!issueKey) return null;
  return (
    <div style={{
      minHeight: '100vh', background: ui.page, color: ui.fg, fontFamily: FONT,
      display: 'flex', flexDirection: 'column',
    }}>
      <div style={{
        display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap',
        padding: '10px 16px', borderBottom: `1px solid ${ui.border}`, background: ui.card,
      }}>
        <strong style={{ fontSize: 14 }}>{issueKey}</strong>
        {/* A WAY BACK, because a tab opened from a structure is still part of
            somebody's afternoon — and a real href, so it is a link and not a
            button that pretends to be one. */}
        {backHref ? (
          <a href={backHref} style={{
            marginLeft: 'auto', fontSize: 12, fontWeight: 700, padding: '4px 11px',
            borderRadius: 999, border: `1px solid ${ui.border}`, background: ui.card,
            color: ui.muted, textDecoration: 'none', fontFamily: FONT,
          }}>← Back to {backLabel}</a>
        ) : null}
      </div>
      {/* THE WHOLE WINDOW. The tab holds one work item and nothing else, so
          it is not a 1200px column in a sea of grey — a wide screen is used. */}
      <div style={{ flex: '1 1 auto', overflowY: 'auto', padding: '0 16px 20px', width: '100%', boxSizing: 'border-box' }}>
        <PanelBoundary>
          <IssueScreenPanel
            key={issueKey} issueKey={issueKey}
            creationTree={null} siteUrl={null}
            onFieldUpdate={(k, fields) => onChanged && onChanged(k, fields)}
            onParentChange={(k, parent) => onChanged && onChanged(k, { parent: parent ? { key: parent } : null })} />
        </PanelBoundary>
      </div>
    </div>
  );
}
